import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import sellitNegativa from "assets/sellitNegativa.png";
import { FichaIcon } from "assets/iconsSVG/fichaIcon";
import * as S from "./styles";

const DeepLinkRedirect: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const numeroCotacao = searchParams.get("numeroCotacao") || "";

  const openApp = () => {
    const deepLink = `com.sellit.mobile://proposta-detail?numeroCotacao=${numeroCotacao}`;
    window.location.href = deepLink;
  };

  useEffect(() => {
    if (!numeroCotacao) return;
    openApp();
  }, [numeroCotacao]);

  return (
    <S.Wrapper>
      <S.Header>
        <img src={sellitNegativa} alt="Sell.it" height={32} />
      </S.Header>

      <S.Content>
        {!numeroCotacao ? (
          <S.ErrorText>
            Link inválido. Nenhum número de cotação informado.
          </S.ErrorText>
        ) : (
          <S.Card>
            <FichaIcon width={48} height={48} />
            <S.CardLabel>Proposta</S.CardLabel>
            <S.CotacaoValue>{numeroCotacao}</S.CotacaoValue>
            <S.Divider />
            <S.OpenButton onClick={openApp}>
              Abrir Proposta no Sellit
            </S.OpenButton>
          </S.Card>
        )}
      </S.Content>
    </S.Wrapper>
  );
};

export default DeepLinkRedirect;
